__turbopack_context__.v({
  "accordion__body": "rufV6W_accordion__body",
  "accordion__button": "rufV6W_accordion__button",
  "accordion__header": "rufV6W_accordion__header",
});
